<script>
  import SinglePage from './single-page.html'
  export let featured = null;
</script>

<main>
  <!-- <h3 style="padding:1rem;">Cargando Grp v21.2.lasau2022 ...</h3> -->
  <SinglePage />
</main>
